import { Notification } from '../types/Notification';

export type State = { notifications: Notification[]; limit: number };
export const initialState: State = { notifications: [], limit: 0 };

export enum NotificationAction {
    ADD,
    DELETE,
}

export const notificationReducer = (state = initialState, action) => {
    const { type, ...notification } = action;

    switch (type) {
        case NotificationAction.ADD:
            const notifications = [...state.notifications, { ...notification }].splice(-state.limit);
            return { ...state, notifications };
        case NotificationAction.DELETE:
            return { ...state, notifications: state.notifications.filter((it) => it.id !== notification.id) };
        default:
            throw Error(`Unknown reducer action type ${type}.`);
    }
};
